import { createStore } from 'vuex'
import { IStoreState } from '../interfaces/interfaces';

const store = createStore({
	state: {
		q: {
			q1: '',
			q2: '',
			q3: '',
		},
		activeQuestion: 1
	} as IStoreState,
	mutations: {
		updateQ1(state, data) {
			state.q.q1 = data;
		},
		updateQ2(state, data) {
			state.q.q2 = data;
		},
		updateQ3(state, data) {
			state.q.q3 = data;
		},
		updateActiveQuestion(state, data) {
			state.activeQuestion = data;
		}
	}
})

export default store
